module.exports = __webpack_public_path__ + "media/testimonials/customer-2-ffd79f90.png";